module.exports = __webpack_public_path__ + "img/weglot.ae336819.jpg";